export default {
  viewInfo: {},
  accountInfo: {},
  confirmBuy: {
    tips: '',
    show: false,
  },
  viewLoading: false,
  // 授权
  empowerParams: {
    empowerShow: false,
  },
  setAccountInfo: false,
  // 商机默认Index
  businessTab: 0,
}
